__turbopack_context__.v({
  "dropdownMenu": "CXiPSq_dropdownMenu",
  "dropdownWrapper": "CXiPSq_dropdownWrapper",
  "navItem": "CXiPSq_navItem",
  "navItemFooter": "CXiPSq_navItemFooter",
  "subItemWrapper": "CXiPSq_subItemWrapper",
});
